import { useEffect } from 'react';

function useVersionCheck(Refresh = 0) {
  useEffect(() => {
    console.log("currentVersion")
    console.log(Refresh,"currentVersion")
    const interval = setInterval(async () => {
      const response = await fetch('/public/version.json');
      const data = await response.json();
      console.log(data,"currentVersion")
      const currentVersion = localStorage.getItem('appVersion');
      console.log(currentVersion,"currentVersion")
      if (currentVersion && currentVersion !== data.version) {
        //
        if(Refresh === 1){
          window.location.reload(true);
        }
       //
      }   
      if(!currentVersion){
        localStorage.setItem('appVersion', data.version);
      }   
    }, 30000); // Check every 60 seconds

    return () => clearInterval(interval);
  }, [Refresh]);
  console.log("currentVersion")
}

export default useVersionCheck;
